/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const healthyEating = useStore((state) => state.healthyEating);
  const setHealthyEating = useStore((state) => state.setHealthyEating);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.healthyEating.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={healthyEating}
          onChange={(value) => {
            setHealthyEating(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'healthy-eating',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Eating lots of veggies'}>
            <span>🥦</span> {t('onboarding.healthyEating.options.lotsVeggies')}
          </Option>
          <Option value={'Having a balanced diet'}>
            <span>⚖️</span> {t('onboarding.healthyEating.options.balancedDiet')}
          </Option>
          <Option value={'Avoiding sweets'}>
            <span>🍫</span> {t('onboarding.healthyEating.options.avoidingSweets')}
          </Option>
          <Option value={'Feeling good and energized'}>
            <span>😊</span> {t('onboarding.healthyEating.options.feelGoodEnergized')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
